import { render } from "./TablePrefecture.vue?vue&type=template&id=6b23813e"
import script from "./TablePrefecture.vue?vue&type=script&lang=js"
export * from "./TablePrefecture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__